module.exports = __webpack_public_path__ + "static/img/recruit_detail.7d22ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/recruit_detail.png
// module id = Aeo6
// module chunks = 1